import { User } from "models/User";
import { Reducer } from 'redux';
import { IUserActions, UserActionType } from "redux/actions/settings/UserActions";
const initialState: User[] | null = null;

export const userReducer: Reducer<User[] | null, IUserActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case UserActionType.FETCH_ALLUSERDATA_SUCCESS:
                {
                    return action.returnPayload as User[];
                }
            case UserActionType.ADD_ROLE_SUCCESS:
            case UserActionType.REMOVE_ROLE_SUCCESS:
                {
                    let newUsers: User[] = Object.assign(state!);
                    const retUser = { ...action.returnPayload } as User;
                    return newUsers.map(nu => {
                        if (nu.email === retUser.email)
                            return retUser;
                        else
                            return nu;
                    });
                }
            case UserActionType.ADD_USER_SUCCESS: 
            case UserActionType.DELETE_USER_SUCCESS: 
            {
                let newUsers: User[] = Object.assign(state!);
                const retUser = { ...action.returnPayload } as User;
                newUsers.push(retUser);
                return newUsers;
            }
            default:
                return state;
        }
    };



